module.exports = __webpack_public_path__ + "img/coverimg2.bd627255.png";